"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var default_1 = require("./default");
/**
 * 所有的响应式主题配置
 */
var RESPONSIVE_THEME_MAP = {
    default: default_1.DEFAULT_RESPONSIVE_THEME,
};
/**
 * 添加一个响应式主题配置
 * @param name
 * @param theme
 */
function registerResponsiveTheme(name, theme) {
    RESPONSIVE_THEME_MAP[name.toLowerCase()] = _.deepMix({}, default_1.DEFAULT_RESPONSIVE_THEME, theme);
}
exports.registerResponsiveTheme = registerResponsiveTheme;
/**
 * 获取一个响应式主题配置，如果找不到则返回默认
 * @param name
 */
function getResponsiveTheme(name) {
    var theme = RESPONSIVE_THEME_MAP[name.toLowerCase()];
    return theme ? theme : default_1.DEFAULT_RESPONSIVE_THEME;
}
exports.getResponsiveTheme = getResponsiveTheme;
//# sourceMappingURL=theme.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/util/responsive/theme.js
// module id = 315
// module chunks = 37